/** 重新整理目前頁面（抽成模組，方便測試替換） */
export function reloadPage() {
  window.location.reload();
}
